/**
 * 白バラ牛乳 Shopify Theme - Main JavaScript
 */

(function() {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var passiveOpt = { passive: true };

  function rafThrottle(fn) {
    var ticking = false;
    return function() {
      var context = this, args = arguments;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        fn.apply(context, args);
        ticking = false;
      });
    };
  }

  function onIdle(fn, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(fn, { timeout: timeout || 2000 });
    } else {
      setTimeout(fn, 1);
    }
  }

  // ============================================
  // Cart Count - 動的カート数更新
  // ============================================
  function updateCartCount() {
    fetch('/cart.json')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var countEls = document.querySelectorAll('.header__cart-count, [data-cart-count]');
        countEls.forEach(function(el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-cart-count', cart.item_count);
        });
        var mobileCartCount = document.querySelector('.mobile-menu-cart-count');
        if (mobileCartCount) mobileCartCount.textContent = cart.item_count;
      })
      .catch(function(err) {
        console.error('Cart count update error:', err);
      });
  }

  // /cart ページ自身ではスキップ。それ以外はアイドル時に更新
  if (!/^\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search)) {
    onIdle(updateCartCount, 3000);
  }

  // ============================================
  // Sticky Header (shadow on scroll)
  // ============================================
  var header = document.querySelector('.header');
  if (header) {
    var onHeaderScroll = rafThrottle(function() {
      if (window.pageYOffset > 120) {
        header.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
      } else {
        header.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)';
      }
    });
    window.addEventListener('scroll', onHeaderScroll, passiveOpt);
  }

  // ============================================
  // Mobile Menu Toggle
  // ============================================
  (function() {
    var menuBtn = document.getElementById('mobileMenuBtn');
    var drawer = document.getElementById('mobileMenuDrawer');
    var overlay = document.getElementById('mobileMenuOverlay');
    var closeBtn = document.getElementById('mobileMenuClose');
    if (!drawer || !overlay) return;

    function openMenu() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
    if (menuBtn) menuBtn.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);
  })();

  // ============================================
  // Header Inline Search Toggle
  // ============================================
  var searchToggle = document.getElementById('headerSearchToggle');
  var searchBar = document.getElementById('headerSearch');
  var searchInput = document.getElementById('headerSearchInput');
  var searchClose = document.getElementById('headerSearchClose');

  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function() {
      var isOpen = searchBar.classList.contains('is-open');
      if (isOpen) {
        searchBar.classList.remove('is-open');
        searchBar.setAttribute('aria-hidden', 'true');
      } else {
        searchBar.classList.add('is-open');
        searchBar.setAttribute('aria-hidden', 'false');
        if (searchInput) {
          setTimeout(function() { searchInput.focus(); }, 100);
        }
      }
    });

    if (searchClose) {
      searchClose.addEventListener('click', function() {
        searchBar.classList.remove('is-open');
        searchBar.setAttribute('aria-hidden', 'true');
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchBar.classList.contains('is-open')) {
        searchBar.classList.remove('is-open');
        searchBar.setAttribute('aria-hidden', 'true');
        searchToggle.focus();
      }
    });
  }

  // ============================================
  // Smooth scroll for anchor links
  // ============================================
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ============================================
  // Lazy loading images (fallback for older browsers)
  // ============================================
  if ('IntersectionObserver' in window) {
    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    var imageObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
          }
          imageObserver.unobserve(img);
        }
      });
    });
    lazyImages.forEach(function(img) { imageObserver.observe(img); });
  }

  // ============================================
  // Cart Drawer
  // ============================================
  var cartDrawerApi = (function() {
    var drawer = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartDrawerOverlay');
    if (!drawer || !overlay) return null;

    var isOnCartPage = /^\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search);
    var refreshing = null;
    var updateTimers = {};
    var isUpdatingItem = {};

    function openDrawer() {
      if (isOnCartPage) return;
      overlay.hidden = false;
      // force reflow so transition runs
      void overlay.offsetWidth;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      var closeBtn = drawer.querySelector('#cartDrawerClose');
      if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 50);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';
      setTimeout(function() {
        if (!drawer.classList.contains('is-open')) overlay.hidden = true;
      }, 300);
    }

    function refreshDrawer() {
      if (refreshing) return refreshing;
      refreshing = fetch('/?section_id=cart-drawer', { headers: { Accept: 'text/html' } })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          var newDrawer = wrap.querySelector('#cartDrawer');
          if (newDrawer) {
            drawer.innerHTML = newDrawer.innerHTML;
            var count = newDrawer.getAttribute('data-cart-item-count') || '0';
            drawer.setAttribute('data-cart-item-count', count);
            updateAllCartCounts(parseInt(count, 10) || 0);
          }
        })
        .catch(function(err) { console.error('Drawer refresh error:', err); })
        .then(function() { refreshing = null; });
      return refreshing;
    }

    function setItemUpdating(itemEl, on) {
      if (!itemEl) return;
      if (on) itemEl.classList.add('is-updating');
      else itemEl.classList.remove('is-updating');
    }

    function changeLine(key, quantity, itemEl) {
      if (isUpdatingItem[key]) return;
      isUpdatingItem[key] = true;
      setItemUpdating(itemEl, true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function(r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
        .then(function(cart) {
          updateAllCartCounts(cart.item_count);
          return refreshDrawer();
        })
        .catch(function(err) { console.error(err); setItemUpdating(itemEl, false); })
        .then(function() { isUpdatingItem[key] = false; });
    }

    function scheduleChange(itemEl) {
      var key = itemEl.getAttribute('data-key');
      var input = itemEl.querySelector('[data-cart-qty]');
      if (!key || !input) return;
      clearTimeout(updateTimers[key]);
      updateTimers[key] = setTimeout(function() {
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        changeLine(key, qty, itemEl);
      }, 280);
    }

    drawer.addEventListener('click', function(e) {
      if (e.target.closest('#cartDrawerClose')) { closeDrawer(); return; }
      var stepBtn = e.target.closest('[data-qty-step]');
      if (stepBtn) {
        var item = stepBtn.closest('[data-cart-item]');
        if (!item) return;
        var input = item.querySelector('[data-cart-qty]');
        if (!input) return;
        var step = parseInt(stepBtn.getAttribute('data-qty-step'), 10);
        var current = parseInt(input.value, 10) || 0;
        var next = Math.max(0, current + step);
        if (next === current) return;
        input.value = next;
        scheduleChange(item);
        return;
      }
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        var item2 = removeBtn.closest('[data-cart-item]');
        if (!item2) return;
        var key = item2.getAttribute('data-key');
        clearTimeout(updateTimers[key]);
        changeLine(key, 0, item2);
      }
    });

    drawer.addEventListener('input', function(e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      var item = input.closest('[data-cart-item]');
      if (item) scheduleChange(item);
    });

    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Hook the header cart icon: open drawer instead of navigating
    var headerCartBtn = document.getElementById('headerCartBtn');
    if (headerCartBtn && !isOnCartPage) {
      headerCartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        refreshDrawer().then(openDrawer);
      });
    }

    return {
      open: openDrawer,
      close: closeDrawer,
      refresh: refreshDrawer,
      isOnCartPage: isOnCartPage
    };
  })();

  function updateAllCartCounts(count) {
    document.querySelectorAll('.header__cart-count, [data-cart-count]').forEach(function(el) {
      el.textContent = count;
      el.setAttribute('data-cart-count', count);
    });
    var mobile = document.querySelector('.mobile-menu-cart-count');
    if (mobile) mobile.textContent = count;
  }

  function afterAddSuccess() {
    if (cartDrawerApi && !cartDrawerApi.isOnCartPage) {
      cartDrawerApi.refresh().then(cartDrawerApi.open);
    } else {
      updateCartCount();
    }
  }

  // ============================================
  // Add to Cart Ajax
  // ============================================
  document.querySelectorAll('.product-card__cart-btn[href^="/cart/add"]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var url = this.href;
      fetch(url, {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart add failed');
        afterAddSuccess();
      })
      .catch(function(err) {
        console.error('Cart error:', err);
        window.location.href = url;
      });
    });
  });

  var productForms = document.querySelectorAll('form[action="/cart/add"]');
  productForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      if (e.submitter && e.submitter.name === 'checkout') return;

      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]:not([name="checkout"])');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function() {
        afterAddSuccess();
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        form.submit();
      })
      .then(function() {
        if (submitBtn) submitBtn.disabled = false;
      });
    });
  });

  // ============================================
  // Scroll to top button (static in DOM, JS controls visibility only)
  // ============================================
  var scrollTopBtn = document.querySelector('.scroll-to-top');
  if (scrollTopBtn) {
    scrollTopBtn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    var onScrollTopVis = rafThrottle(function() {
      if (window.pageYOffset > 400) {
        scrollTopBtn.classList.add('is-visible');
      } else {
        scrollTopBtn.classList.remove('is-visible');
      }
    });
    window.addEventListener('scroll', onScrollTopVis, passiveOpt);
  }

  // ============================================
  // Scroll-triggered fade-in for sections
  // ============================================
  if ('IntersectionObserver' in window) {
    var sectionEls = document.querySelectorAll(
      '.section--lg, .section--md, .gift-section, .category-icons, .popular-ranking, .news-section, .instagram-section'
    );

    var sectionObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          sectionObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' });

    sectionEls.forEach(function(el) {
      if (!el.classList.contains('scroll-animate') &&
          !el.classList.contains('scroll-animate--left') &&
          !el.classList.contains('scroll-animate--right') &&
          !el.classList.contains('scroll-animate--scale')) {
        el.classList.add('scroll-animate');
      }
      sectionObserver.observe(el);
    });

    var staggerContainers = document.querySelectorAll('.category-icons__grid, .ranking-grid, .instagram-section__grid');
    staggerContainers.forEach(function(container) {
      var children = container.children;
      for (var i = 0; i < children.length; i++) {
        children[i].classList.add('scroll-animate', 'stagger-child');
      }
    });

    var childObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var children = entry.target.querySelectorAll('.stagger-child');
          children.forEach(function(child) {
            child.classList.add('is-visible');
          });
          childObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    staggerContainers.forEach(function(c) { childObserver.observe(c); });

    var giftSections = document.querySelectorAll('.gift-section');
    giftSections.forEach(function(section) {
      var imageHalf = section.querySelector('.gift-section__image-half');
      var textHalf = section.querySelector('.gift-section__text-half');
      var isReversed = section.querySelector('.gift-section__inner--reverse');

      if (imageHalf) {
        imageHalf.classList.add(isReversed ? 'scroll-animate--right' : 'scroll-animate--left');
        sectionObserver.observe(imageHalf);
      }
      if (textHalf) {
        textHalf.classList.add(isReversed ? 'scroll-animate--left' : 'scroll-animate--right');
        sectionObserver.observe(textHalf);
      }
    });
  }

  // ============================================
  // Parallax on gift / brand-story images (desktop, motion OK)
  // Only attach the scroll listener when at least one section is in view.
  // ============================================
  if (!prefersReduced && window.innerWidth > 768 && 'IntersectionObserver' in window) {
    var splitSections = document.querySelectorAll('.gift-section__image-half');
    if (splitSections.length) {
      var inViewSections = new Set();
      var scrollAttached = false;

      var onParallaxScroll = rafThrottle(function() {
        var winH = window.innerHeight;
        inViewSections.forEach(function(el) {
          var rect = el.getBoundingClientRect();
          if (rect.top < winH && rect.bottom > 0) {
            var progress = (winH - rect.top) / (winH + rect.height);
            var offset = (progress - 0.5) * 50;
            var img = el.querySelector('.gift-section__image');
            if (img) img.style.transform = 'translateY(' + offset + 'px) scale(1.04)';
          }
        });
      });

      function attachScroll() {
        if (scrollAttached) return;
        scrollAttached = true;
        window.addEventListener('scroll', onParallaxScroll, passiveOpt);
      }
      function detachScroll() {
        if (!scrollAttached) return;
        scrollAttached = false;
        window.removeEventListener('scroll', onParallaxScroll, passiveOpt);
      }

      var parallaxObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            inViewSections.add(entry.target);
          } else {
            inViewSections.delete(entry.target);
          }
        });
        if (inViewSections.size > 0) attachScroll();
        else detachScroll();
      }, { rootMargin: '100px 0px' });

      splitSections.forEach(function(el) { parallaxObserver.observe(el); });
    }
  }

  // ============================================
  // Counter animation for brand story stats
  // ============================================
  var statValues = document.querySelectorAll('.brand-story__stat-value');
  if (statValues.length && 'IntersectionObserver' in window) {
    var counted = false;
    var statsContainer = statValues[0].closest('.brand-story__stats');
    if (statsContainer) {
      var counterObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && !counted) {
            counted = true;
            statValues.forEach(function(el) {
              var text = el.textContent.trim();
              var unitSpan = el.querySelector('.brand-story__stat-unit');
              var unitText = unitSpan ? unitSpan.textContent : '';
              var numText = text.replace(unitText, '').trim();
              var target = parseInt(numText, 10);
              if (isNaN(target)) return;

              var duration = 1600;
              var start = performance.now();

              function animate(now) {
                var elapsed = now - start;
                var progress = Math.min(elapsed / duration, 1);
                var eased = 1 - Math.pow(1 - progress, 3);
                var current = Math.round(target * eased);
                el.innerHTML = current + (unitSpan ? '<span class="brand-story__stat-unit">' + unitText + '</span>' : '');
                if (progress < 1) requestAnimationFrame(animate);
              }
              requestAnimationFrame(animate);
            });
            counterObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });
      counterObserver.observe(statsContainer);
    }
  }

  // ============================================
  // Magnetic hover for CTA buttons (desktop)
  // ============================================
  if (window.innerWidth > 1024 && !prefersReduced) {
    var ctaButtons = document.querySelectorAll('.hero-slider__btn, .gift-section__btn');
    ctaButtons.forEach(function(btn) {
      btn.addEventListener('mousemove', function(e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = 'translate(' + (x * 0.15) + 'px,' + (y * 0.15) + 'px)';
      });
      btn.addEventListener('mouseleave', function() {
        btn.style.transform = '';
      });
    });
  }

})();
